import * as React from 'react';
import PropTypes from 'prop-types';

import { defaultContentElementTypes, specialContentElementTypes } from '../../../constants';

// eslint-disable-next-line import/no-cycle -- ok because ReadMore can display content via TaskContent
import ReadMore from './ReadMore';
import LinkedResponse from './LinkedResponse';
import DefaultElementContent from './DefaultElementContent';
import ConnectedBoxes from './ConnectedBoxes';

export const getHtmlContentPosition = (elementType, contentPositionFromSetting) => {
    switch (elementType) {
    case specialContentElementTypes.hidden:
    case defaultContentElementTypes.readMore:
        return -1;
    default:
        return Number(contentPositionFromSetting || 0);
    }
}


const TaskElementContent = ({ element, customElementHandler, ...props }) => {
    switch (element.elementType) {
    case specialContentElementTypes.hidden:
        return null;
    case defaultContentElementTypes.readMore:
        return <ReadMore element={element} {...props} />
    case defaultContentElementTypes.linkedResponse:
        return <LinkedResponse element={element} {...props} />
    case specialContentElementTypes.connectedBoxes:
        return <ConnectedBoxes element={element} {...props} />
    default:
        if (customElementHandler) {
            const customHandeled = customElementHandler({ element, ...props });
            if (customHandeled) {
                return customHandeled;
            }
        }
        return <DefaultElementContent element={element} {...props} />;
    }
};

TaskElementContent.propTypes = {
    element: PropTypes.object.isRequired,
    customElementHandler: PropTypes.func,
}

TaskElementContent.defaultProps = {
    customElementHandler: null,
}

export default TaskElementContent;
